import { getKeycloak } from "@/restricted-library/plugins/keycloak";
import store from "./store";

/**
 * Build request parameters to be passed to Swaggerclient library
 * @param {*} requestBody The request body
 */
const buildRequest = requestBody => {
  return {
    requestBody: requestBody,
    server: "{protocol}://{hostAndPort}{basePath}{apiPath}",
    serverVariables: {
      protocol: process.env.VUE_APP_ONSTAGE_GATEWAY_PROTOCOL,
      hostAndPort: process.env.VUE_APP_ONSTAGE_GATEWAY_HOST_AND_PORT,
      basePath: process.env.VUE_APP_ONSTAGE_GATEWAY_BASE_PATH
    }
  };
};

const addClientApplicationKeyInterceptor = (store, request) => {
  if (store?.getters["clientApplicationKey"]) {
    request.headers["X-OnAir-ClientAppKey"] =
      store.getters["clientApplicationKey"];
  }
};

/**
 * Add the keycloak bearer token authorization header to the request.
 *
 * @param {object} store The store.
 * @param {*} request The request.
 */
const addBearerTokenAuthHeaderInterceptor = request => {
  let kc = getKeycloak();
  let kcToken = kc ? kc.token : null;
  request.headers["Authorization"] = `Bearer ${kcToken}`;
};

/**
 * Check if it is unauthorized response error and handle it.
 *
 * @param {object} store The store.
 * @param {object} response  The response.
 */
const myResponseInterceptor = function (store, response) {
  // checkAndManageUnauthorizedError(store, response);
  let loginRedirectionErrors = [401, 403];
  if (loginRedirectionErrors.includes(response?.status)) {
    store?.commit("error/setError", response, {
      root: true
    });
    store?.commit("loading/closeLoadingDialog", null, { root: true });
  }
  if (response?.status >= 500) {
    store?.commit("error/setError", "dialog.error.serverError", {
      root: true
    });
    store?.commit("loading/closeLoadingDialog", null, { root: true });
  }
  return response;
};

// Helper per creare il client con import dinamico
const importSwaggerClient = async () => {
  const { default: SwaggerClient } = await import("swagger-client");
  if (SwaggerClient.http) {
    SwaggerClient.http.withCredentials = true;
  }
  return SwaggerClient;
};

const createSwaggerClient = async (url, withBearer = false) => {
  const SwaggerClient = await importSwaggerClient();
  return new SwaggerClient(url, {
    requestInterceptor: async request => {
      if (!request.loadSpec) {
        request.headers["Accept"] = "application/json";
        addClientApplicationKeyInterceptor(store, request);
        if (withBearer) addBearerTokenAuthHeaderInterceptor(request);
      }
      return request;
    },
    responseInterceptor: myResponseInterceptor,
    authorizations: {}
  });
};

const baseURL = window.location.origin;
const userSwaggerClient = createSwaggerClient(`${baseURL}/user-v1.json`, true);
const nestCommonSwaggerClient = createSwaggerClient(
  `${baseURL}/nestcommon-v1.json`,
  false
);
const memberSwaggerClient = createSwaggerClient(
  `${baseURL}/member-v1.json`,
  true
);

export default {
  userSwaggerClient,
  nestCommonSwaggerClient,
  memberSwaggerClient,
  buildRequest
};
